import Accordion from "components/Accordion";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { AccordionAdapterProps } from ".";

const AccordionAdapter = ({ blok: { content: items, variant } }: ReactStoryblokComponent<AccordionAdapterProps>) => (
  <Accordion items={items} variant={variant} />
);

export default AccordionAdapter;
